import styled from '@emotion/styled'
import React from 'react'
import {
  alignItems,
  grid,
  maxWidth,
  minWidth,
  space,
  width,
  AlignItemsProps,
  MaxWidthProps,
  MinWidthProps,
  SpaceProps,
  WidthProps,
  GridProps as GridPropsStyledSystem
} from 'styled-system'

export interface GridProps
  extends AlignItemsProps,
    SpaceProps,
    GridPropsStyledSystem,
    WidthProps,
    MinWidthProps,
    MaxWidthProps {
  /**
   * Takes a string to output a class. Related to emotion - It lets another component style it
   */
  className?: string
}

/**
 * @desc This component is meant for internal use only until support becomes more ubiquitous.
 */
const Grid: React.FC<GridProps> = ({ className, children, ...other }) => {
  return (
    <StyledGrid className={className} {...other}>
      {children}
    </StyledGrid>
  )
}

export default Grid

const StyledGrid = styled.div(
  {
    display: 'grid'
  },
  /**
   * note: It only imports alignItems from flex. Replace it with 'flex
   * if more flex elements as added to this component
   */
  alignItems,
  grid,
  minWidth,
  maxWidth,
  space,
  width
)
